import type { SessionState } from '@novachat/client';
import { useSyncExternalStore } from 'react';
import { client } from '../lib/client';

const subscribe = (listener: () => void) => client.session.subscribe(listener);
const snapshot = () => client.session.state;

export function useSession(): SessionState {
  return useSyncExternalStore(subscribe, snapshot);
}
